export enum StorageCategoryFilters {
    SPORT = 'no_sport',
    RAW = 'raw_material',
}
